import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'lok',
  templateUrl: './lok.component.html'
})
export class LokComponent {
  @Input() lok: string;
  @Input() loksVoor: string[];
  @Input() loksAchter: string[];

  @Output()
  notify: EventEmitter<any> = new EventEmitter<any>();

  addRemoveLok(loks, lok) {
    let lokIndex = loks.indexOf(lok);
    if (lokIndex > -1) {
      loks.splice(lokIndex, 1);
    }
    else {
      loks.push(lok);
    }
    this.notify.emit();
  }
}
